import { render } from "./QualityChart.vue?vue&type=template&id=36eb6a8c&scoped=true"
import script from "./QualityChart.vue?vue&type=script&lang=js"
export * from "./QualityChart.vue?vue&type=script&lang=js"

import "./QualityChart.vue?vue&type=style&index=0&id=36eb6a8c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36eb6a8c"]])

export default __exports__